import React from "react";

const Lock = props => {
  let classes = "fa fa-lock fa-lg";
  if (!props.locked) classes = "fa fa-unlock fa-lg";

 if (props.locked)  classes += " text-danger";
  return (

    <i
      onClick={props.onClick}
      style={{ cursor: "pointer" }}
      className={classes}
      aria-hidden="true"
    />
  );
};

export default Lock;



// WEBPACK FOOTER //
// ./src/components/common/lock.jsx